import { RG_TYPE as t } from "@project-rouge/rg-core";
import { getLevelVerticalWallArea as l } from "./index35.js";
const o = (e, r) => l(e, r, [t.EmptySpace]);
export {
  o as getLevelCommercialWallArea
};
//# sourceMappingURL=index12.js.map
